// dbHandle.js

import { cppDbOpen, cppDbTableExist, cppDbExecSql, cppDbExecQuerySql, cppDbClose } from "../api/cpp";

import { parseTime } from "./index"

const dbName = "../emcache.db"
const emTableName = "em"
const maxCount = 10000
const deleteCount = 100

export async function initLocalDb() {
    const reslut = await cppDbOpen(dbName)
    if (reslut) {
        const tableExist = await cppDbTableExist(emTableName)
        if (!tableExist) {
            await cppDbExecSql(`CREATE TABLE ${emTableName} (id INTEGER PRIMARY KEY AUTOINCREMENT UNIQUE NOT NULL,
                                music_name        STRING,
                                music_author      STRING,
                                keynote           STRING,
                                tune              INT,
                                updatetime        DATETIME NOT NULL,
                                music_name_author STRING NOT NULL,
                                keynote_cache STRING,
                                vocals INT,
                                rate INT,
                                humanize INT,
                                flex INT,
                                vibrato INT,
                                tracking INT,
                                aifirst INT,
                                ai_keynote STRING)`
                                )
            await cppDbExecSql(`CREATE UNIQUE INDEX em_index ON ${emTableName} (music_name_author)`)
        } else {
            // 检查一下数据量 超过最大数量就删除一部分
            removeOnMax()
            // 新增缓存基调字段 新增消人声字段
            cppDbExecSql(`ALTER TABLE ${emTableName} ADD keynote_cache STRING`)
            cppDbExecSql(`ALTER TABLE ${emTableName} ADD vocals INT`)
            // 新增字段 速率、拟人、颤音、弹性、跟踪
            cppDbExecSql(`ALTER TABLE ${emTableName} ADD rate INT`)
            cppDbExecSql(`ALTER TABLE ${emTableName} ADD humanize INT`)
            cppDbExecSql(`ALTER TABLE ${emTableName} ADD flex INT`)
            cppDbExecSql(`ALTER TABLE ${emTableName} ADD vibrato INT`)
            cppDbExecSql(`ALTER TABLE ${emTableName} ADD tracking INT`)
            cppDbExecSql(`ALTER TABLE ${emTableName} ADD aifirst INT`)
            // 新增字段 AI基调
            cppDbExecSql(`ALTER TABLE ${emTableName} ADD ai_keynote STRING`)
        }
    } else {
        await cppDbExecSql(`CREATE DATABASE ${dbName}`)
        await cppDbExecSql(`CREATE TABLE ${emTableName} (id INTEGER PRIMARY KEY AUTOINCREMENT UNIQUE NOT NULL,
                                music_name        STRING,
                                music_author      STRING,
                                keynote           STRING,
                                tune              INT,
                                updatetime        DATETIME NOT NULL,
                                music_name_author STRING NOT NULL,
                                keynote_cache STRING,
                                vocals INT,
                                rate INT,
                                humanize INT,
                                flex INT,
                                vibrato INT,
                                tracking INT,
                                aifirst INT,
                                ai_keynote STRING)`
                            )
        await cppDbExecSql(`CREATE UNIQUE INDEX em_index ON ${emTableName} (music_name_author)`)
        await cppDbOpen(dbName)
    }
}

// 检查某条数据是否存在
function isExist(music_name_author) {
    const found = cppDbExecQuerySql(`SELECT id FROM ${emTableName} WHERE music_name_author="${music_name_author}" LIMIT 1`)
    if (found && Array.isArray(found) && found.length) {
        return true
    }
    return false
}

// 获取本地歌曲信息
export function getMusicInfoFromLoadlDb(playerData) {
    const music_name_author = hanldeIndex(playerData);
    if (!music_name_author) {
        return false
    }
    const found = cppDbExecQuerySql(`SELECT keynote,tune,vocals,rate,humanize,flex,vibrato,tracking,aifirst,ai_keynote FROM ${emTableName} WHERE music_name_author="${music_name_author}" LIMIT 1`)
    if (found && Array.isArray(found) && found.length && Array.isArray(found[0]) && found[0].length) {
        // 每次查询更新一次时间
        cppDbExecSql(`UPDATE ${emTableName} SET updatetime="${parseTime(new Date())}" WHERE music_name_author="${music_name_author}"`)
        return found[0]
    }
    return false
}

// 更新本地库升降调 不存在就添加 存在就更新
export async function updateLocalDbTune(tune, playerData) {
    const music_name_author = hanldeIndex(playerData);
    if (!music_name_author) {
        return false
    }
    tune = parseInt(tune, 10) || 0
    if (isExist(music_name_author)) {
        cppDbExecSql(`UPDATE ${emTableName} SET tune=${tune},updatetime="${parseTime(new Date())}" WHERE music_name_author="${music_name_author}"`)
    } else {
        if (tune !== 0) {
            // 升降调为0时就不添加了
            cppDbExecSql(`INSERT INTO ${emTableName}(music_name, music_author, tune, updatetime, music_name_author) VALUES("${playerData.musicName}", "${playerData.musicAuthor}", "${tune}", "${parseTime(new Date())}", "${music_name_author}")`)
        }
    }
}
// 同时更新所有电音参数
export function updateEmValue(obj, playerData) {
    const music_name_author = hanldeIndex(playerData);
    if (!music_name_author || isEmptyObject(obj)) {
        return false
    }
    let updateStr = ''
    let addNameStr = ''
    let addValueStr = ''
    for (const key in obj) {
        updateStr = `${updateStr}${key}=${obj[key]},`
        addNameStr = `${addNameStr}${key},`
        addValueStr = `${addValueStr}"${obj[key]}",`
    }
    if (isExist(music_name_author)) {
        cppDbExecSql(`UPDATE ${emTableName} SET ${updateStr}updatetime="${parseTime(new Date())}" WHERE music_name_author="${music_name_author}"`)
    } else {
        cppDbExecSql(`INSERT INTO ${emTableName}(music_name, music_author, ${addNameStr} updatetime, music_name_author) VALUES("${playerData.musicName}", "${playerData.musicAuthor}", ${addValueStr} "${parseTime(new Date())}", "${music_name_author}")`)
    }
}
function isEmptyObject(obj) {
    return JSON.stringify(obj) === '{}' && obj.constructor === Object;
}
// 更新速率 不存在就添加 存在就更新
export function updateLocalDbEmRate(value, playerData) {
    const fun = updateField("rate");
    fun(value, playerData)
}
// 更新拟人 不存在就添加 存在就更新
export function updateLocalDbEmHumanize(value, playerData) {
    const fun = updateField("humanize");
    fun(value, playerData)
}
// 更新弹性 不存在就添加 存在就更新
export function updateLocalDbEmFlex(value, playerData) {
    const fun = updateField("flex");
    fun(value, playerData)
}
// 更新颤音 不存在就添加 存在就更新
export function updateLocalDbEmVibrato(value, playerData) {
    const fun = updateField("vibrato");
    fun(value, playerData)
}
// 更新跟踪 不存在就添加 存在就更新
export function updateLocalDbEmTracking(value, playerData) {
    const fun = updateField("tracking");
    fun(value, playerData)
}
// 更新AI基调 不存在就添加 存在就更新
export function updateLocalDbAiEm(em, playerData) {
    const keynote = handleEm(em);
    if (!keynote) {
        return false;
    }    
    const fun = updateStrField("ai_keynote");
    fun(keynote, playerData);
}

// 更新本地库 不存在就添加 存在就更新
export async function updateLocalDbEm(em, playerData) {
    const music_name_author = hanldeIndex(playerData);
    if (!music_name_author) {
        return false
    }
    const keynote = handleEm(em);
    if (!keynote) {
        return false;
    }    
    if (isExist(music_name_author)) {
        cppDbExecSql(`UPDATE ${emTableName} SET keynote="${keynote}",updatetime="${parseTime(new Date())}" WHERE music_name_author="${music_name_author}"`)
    } else {        
        cppDbExecSql(`INSERT INTO ${emTableName}(music_name, music_author, keynote, updatetime, music_name_author) VALUES("${playerData.musicName}", "${playerData.musicAuthor}", "${keynote}", "${parseTime(new Date())}", "${music_name_author}")`)
    }
}

// 更新是否AI优先 不存在就添加 存在就更新
export function updateAiFirst(value, playerData) {
    if (value) {
        // 如果添加AI基调优先 则需要删除本地基调
        const music_name_author = hanldeIndex(playerData);
        if (!music_name_author) {
            return false
        }
        if (isExist(music_name_author)) {            
            cppDbExecSql(`UPDATE ${emTableName} SET aifirst=${value},keynote=null,updatetime="${parseTime(new Date())}" WHERE music_name_author="${music_name_author}"`)
        } else {
            cppDbExecSql(`INSERT INTO ${emTableName}(music_name, music_author, aifirst, updatetime, music_name_author) VALUES("${playerData.musicName}", "${playerData.musicAuthor}", "${value}", "${parseTime(new Date())}", "${music_name_author}")`)
        }
    } else {
        const fun = updateField("aifirst");
        fun(value, playerData)
    }
}

// 更新一个数字类型参数 不存在就添加 存在就更新
function updateField(name) {
    return (value, playerData) => {
        const music_name_author = hanldeIndex(playerData);
        if (!music_name_author) {
            return false
        }
        if (typeof value !== 'number') {
            value = 0
        }
        if (isExist(music_name_author)) {
            cppDbExecSql(`UPDATE ${emTableName} SET ${name}=${value},updatetime="${parseTime(new Date())}" WHERE music_name_author="${music_name_author}"`)
        } else {
            cppDbExecSql(`INSERT INTO ${emTableName}(music_name, music_author, ${name}, updatetime, music_name_author) VALUES("${playerData.musicName}", "${playerData.musicAuthor}", "${value}", "${parseTime(new Date())}", "${music_name_author}")`)
        }
    }
}
// 更新一个字符串类型参数 不存在就添加 存在就更新
function updateStrField(name) {
    return (value, playerData) => {
        const music_name_author = hanldeIndex(playerData);
        if (!music_name_author) {
            return false
        }
        if (typeof value !== 'string') {
            value = ""
        }
        if (isExist(music_name_author)) {
            cppDbExecSql(`UPDATE ${emTableName} SET ${name}="${value}",updatetime="${parseTime(new Date())}" WHERE music_name_author="${music_name_author}"`)
        } else {
            cppDbExecSql(`INSERT INTO ${emTableName}(music_name, music_author, ${name}, updatetime, music_name_author) VALUES("${playerData.musicName}", "${playerData.musicAuthor}", "${value}", "${parseTime(new Date())}", "${music_name_author}")`)
        }
    }
}

// 更新本地库消人声 不存在就添加 存在就更新
export async function updateLocalDbVocals(vocals, playerData) {
    const music_name_author = hanldeIndex(playerData);
    if (!music_name_author) {
        return false
    }
    vocals = parseInt(vocals, 10) || 0
    if (isExist(music_name_author)) {
        cppDbExecSql(`UPDATE ${emTableName} SET vocals=${vocals},updatetime="${parseTime(new Date())}" WHERE music_name_author="${music_name_author}"`)
    } else {
        if (vocals !== 0) {
            // 为0时就不添加了
            cppDbExecSql(`INSERT INTO ${emTableName}(music_name, music_author, vocals, updatetime, music_name_author) VALUES("${playerData.musicName}", "${playerData.musicAuthor}", "${vocals}", "${parseTime(new Date())}", "${music_name_author}")`)
        }
    }
}

// 从本地数据库删掉一条基调  同时删除AI缓存基调
export function removeEmFromLocalDb(playerData) {
    const music_name_author = hanldeIndex(playerData);
    if (!music_name_author) {
        return false
    }
    // cppDbExecSql(`DELETE FROM ${emTableName} WHERE music_name_author="${music_name_author}"`)
    // 修改逻辑 不删除将基调设置为空 兼容升降调
    cppDbExecSql(`UPDATE ${emTableName} SET keynote="",ai_keynote="" WHERE music_name_author="${music_name_author}"`)
}

// 检查数据库总条数  达到最大值后删除日期比较老的一部分
export async function removeOnMax() {
    const count = await cppDbExecQuerySql(`SELECT COUNT(music_name_author) FROM ${emTableName}`)
    if (Array.isArray(count) && count.length && Array.isArray(count[0]) && count[0].length && count[0][0] > maxCount) {
        cppDbExecSql(`DELETE FROM ${emTableName} WHERE id in (SELECT id FROM ${emTableName} ORDER BY updatetime LIMIT ${deleteCount})`)
    }
}

// 关闭数据库
export function closeDb() {
    cppDbClose()
}

// 拼接索引music_name_author
function hanldeIndex(playerData) {
    if (!playerData || !playerData.musicName || !playerData.musicAuthor) {
        return false
    }
    const music_name_author = `${playerData.musicName.replace(/\s*/g,"")}_${playerData.musicAuthor.replace(/\s*/g,"")}`;
    return music_name_author;
}

// 拼接基调
function handleEm(em) {
    if (!em || !em.newKeyNote || !em.newScale) {
        return false
    }
    const keynote = `${em.newKeyNote} ${em.newScale}`;
    return keynote;
}
